// extracted by mini-css-extract-plugin
export default {"tabWrapper":"UserRoles_tabWrapper__36gqB","adminContext":"UserRoles_adminContext__sFWJX"};